;(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search)
    let gwpOfferFromUrl = urlParams.get('gwp_offer')
    let gwpOfferFromLocalStorage = localStorage.getItem('gwp_offer')
    if (gwpOfferFromLocalStorage === '1') {
      const bodyElement = document.querySelector('body')
      if (bodyElement) {
        bodyElement.classList.add('show_gwp_hat')
      }
    }
    if (gwpOfferFromUrl) {
      localStorage.setItem('gwp_offer', gwpOfferFromUrl)
    }
    if (gwpOfferFromUrl === '1' || gwpOfferFromLocalStorage === '1') {
      const addBlock = document.querySelector('.gwp-add')
      if (addBlock) {
        addBlock.style.display = 'block'
      }
      const bodyElement = document.querySelector('body')
      if (bodyElement) {
        bodyElement.classList.add('show_gwp_hat')
      }
    } else {
      localStorage.removeItem('gwp_offer')
    }
  })
})()
